import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';

import { UserNotificationService } from '~features/user-notifications/user-notification.service';

@Component({
  selector: 'app-user-notification-toast',
  imports: [NgClass],
  templateUrl: './user-notification-toast.component.html',
  styleUrl: './user-notification-toast.component.css',
})
export class UserNotificationToastComponent {
  userNotificationService = inject(UserNotificationService);
  notifications = this.userNotificationService.notifications;
}
